/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_Order_Partially_RefundedInputs */

const en_my_payments_order_partially_refunded = /** @type {(inputs: My_Payments_Order_Partially_RefundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partly refunded`)
};

const pl_my_payments_order_partially_refunded = /** @type {(inputs: My_Payments_Order_Partially_RefundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Częściowo zwrócone`)
};

/**
* | output |
* | --- |
* | "Partly refunded" |
*
* @param {My_Payments_Order_Partially_RefundedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_order_partially_refunded = /** @type {((inputs?: My_Payments_Order_Partially_RefundedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_Order_Partially_RefundedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_order_partially_refunded(inputs)
	return en_my_payments_order_partially_refunded(inputs)
});